export interface Pax {
  numBags?: number;
}

const getPaxsTotalBags = (paxs: Pax[] = []): number => paxs.reduce(
  (total, { numBags = 0 }) => total + numBags, 0,
);
export default getPaxsTotalBags;
